import React, { useEffect, useRef, useState } from 'react';
import { View } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { PlayerTagProps, TagProps } from "../../../store/types/soc_svc"
import { useIsInViewport } from '../../../utilsv1/helpers';


type TagCardProps = {
    viewer_id:string,
    tag:TagProps,
    player_tag?:PlayerTagProps,
    onFollow: (tag:TagProps) => void
}

const TagCard = ({ viewer_id, tag, player_tag, onFollow }:TagCardProps) => {
    const [ statusChecked, setStatusChecked ] = useState(false)
    const tag_ref = useRef()
    const isInViewport1 = useIsInViewport(tag_ref)

    useEffect(() => {
        if(isInViewport1 && !statusChecked){
        }
    },[isInViewport1])

    const handleFollow = () => {
        if(!onFollow){ return }
        onFollow(tag)
    }

    const following = player_tag?.status === 'following' ? true : false
    return (
        <View ref={tag_ref} style={{ flexDirection:'row', justifyContent:'space-between', padding:10 }}>
            <View>
                <Text size={16} color={Colors.brand.midnight} weight='bold' style={{marginBottom:4}}>{tag.tag}</Text>
                <Text size={14} color={Colors.brand.slate} weight='regular'>{tag.follower_count??0} Followers</Text>
            </View>
            <TouchableOpacity style={{ backgroundColor:following?Colors.shades.white:Colors.brand.midnight, borderWidth:1, borderColor:following?Colors.brand.midnight:Colors.shades.white, padding:5, minWidth:100,  borderRadius:20, justifyContent:'center' }} onPress={() => handleFollow()}>
                <Text size={14} color={following?Colors.brand.midnight:Colors.shades.white} textAlign='center'>{following?'Unfollow':'follow'}</Text>
            </TouchableOpacity>
        </View>
    )
}

export default TagCard